import React from 'react';
// eslint-disable-next-line no-unused-vars
import ModelCheck from '../model/ModelCheck';

const ResultExplanation = (props) => {
    /** @type {ModelCheck} */
    const check = props.data

    return (
        <div className='card'>
            <p>{check.checkStatusExplanation}</p> 
        </div>
    )
}

export default ResultExplanation